import ImageSwitcher from "./ImageSwitcher";

export default ImageSwitcher;
